import { observer } from 'mobx-react-lite'
import { getAriaLabel } from 'shared/lib'
import { Avatar, Icon, Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'

import { useBroadcastDetailModalContext } from 'pages/broadcasts/ui/BroadcastActions/ui/BroadcastDetailModal/context/context'
import {
  contactOwnerItem,
  defaultSettingsItem,
  unassignedItem,
} from 'pages/broadcasts/ui/BroadcastView/ui/BroadcastAssignee/store/broadcastAssigneeStore'
import styles from '../styles.module.scss'

export const AssigneeContent = observer(() => {
  const { usersStore } = useEntitiesContext()
  const { assignee } = useBroadcastDetailModalContext()

  const assignedCustom =
    assignee?.type === 'contact_owner'
      ? contactOwnerItem
      : assignee?.type === 'unassigned'
      ? unassignedItem
      : defaultSettingsItem

  const assignedMember = usersStore.getItem(assignee?.member_id)

  return (
    <div>
      <div className={styles.grid}>
        <Typography ariaLabel='Send' variant='text-input-field' className={styles.label}>
          Assignee
        </Typography>
        <div className={styles.value}>
          <div className={styles.row}>
            {assignedMember ? (
              <>
                <div className={styles.icon}>
                  <Avatar
                    info={assignedMember.avatarInfo}
                    online={!assignedMember.isAway}
                    size={16}
                  />
                </div>
                <Typography
                  className={styles.name}
                  variant='body-md-regular'
                  ellipsis
                  pointer
                  ariaLabel={'name'}
                >
                  {assignedMember.name}
                </Typography>
              </>
            ) : assignedCustom ? (
              <>
                <div className={styles.icon}>
                  <Icon icon={assignedCustom.icon} color='var(--content-primary-tertiary)' />
                </div>
                <Typography
                  className={styles.name}
                  variant='body-md-regular'
                  pointer
                  ariaLabel={getAriaLabel(assignedCustom.type)}
                >
                  {assignedCustom.label}
                </Typography>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
})
